/**
 * Creator join — English (t('creatorJoin.…'))
 */
export default {
	// vue-i18n treats | as plural separator; escape literal pipe with {'|'}
	pageTitle: "SeerQ {'|'} Creator Partnership Programme",
	index: {
		banner: {
			eyebrow: "SeerQ Creator Programme",
			title: "Let your wisdom<br /><span>be seen by more people.</span>",
			titleM: "Let your wisdom <span>be seen by more people.</span>",
			desc: "We are looking for creators devoted to personal growth, wellbeing and wisdom. Join SeerQ and connect your expertise with the people who truly need it.",
			recruitTitle: "Now Recruiting Creators In",
			tag1: "Psychology",
			tag2: "Mind–Body Healing",
			tag3: "Tarot & Astrology",
			tag4: "Eastern Metaphysics",
			tag5: "Emotional Wellness",
			joinCta: "Apply as a Creator",
			benefitsCta: "Explore the Benefits",
		},
		download: {
			title: "SeerQ - Every choice, with you.",
			slogan: "See Beyond",
		},
		about: {
			eyebrow: "About SeerQ · Our Brand",
			title: "Making traditional wisdom<br />a guide for modern life.",
			desc: "The world's first cultural wellness super app designed specifically for Asian communities, pioneering a new category of digital wellness guidance rooted in traditional Asian wisdom. It integrates content discovery, commerce and AI-powered services into one intelligent wellness companion—creating a complete “content-to-commerce” ecosystem for holistic health and modern living.",
			highlight1: "<span>· Brand mission: </span>Help you find direction in life",
			highlight2: "<span>· Brand slogan: </span>See the unseen",
			highlight3: "<span>· SeerQ: </span>See Beyond",
		},
		platform: {
			eyebrow: "The SeerQ Creator Platform",
			title: "Where content gets seen<br />and creators get remembered.",
			desc: "SeerQ brings together people interested in Asian cultural wellness, personal growth and Eastern wisdom. It is a <span>creator community where valuable expertise keeps being discovered.</span> Share perspectives, connect with like-minded audiences and turn content influence into lasting personal-brand and commercial value.",
			card1Title: "Create in Every Format",
			card1Desc:
				"Publish short videos, posts, long-form articles, and live streams from one account.",
			card2Title: "Vertical Reach & Community Growth",
			card2Desc:
				"Reach audiences who care about wellness and growth through interest-based recommendations.",
			card3Title: "Creator Profile & Monetisation",
			card3Desc:
				"Build a sustainable homepage, grow your audience, and connect paid content, consulting, and brand deals.",
			beimei: "North America 15%",
			dongnanya: "Southeast Asia 50%",
			rihan: "Japan & South\nKorea 10%",
			qita: "Other Regions 25%",
		},
		audience: {
			eyebrow: "More Than a Content Platform",
			title: "Your next loyal audience is already here.",
			desc: "Reach high-intent users who value quality of life, personal growth and Eastern and Western wisdom—an audience ready to understand, engage with and pay for great content.",
			stat1Value: "426",
			stat1Suffix: "K",
			stat1Label: "Monthly App Users",
			stat2Value: "3,786",
			stat2Suffix: "K",
			stat2Label: "Monthly Content Views",
			stat3Value: "796",
			stat3Suffix: "K",
			stat3Label: "Unique YouTube Viewers",
			stat4Value: "174",
			stat4Suffix: "K",
			stat4Label: "Facebook Followers",
			personaAge: "28-45",
			personaAgeUnit: "Age",
			personaAgeLabel: "Core Age\nGroup",
			personaUserLabel: "Core\nAudience",
			personaTag1: "Professionals",
			personaTag2: "High purchase intent",
			personaTag3: "Growth-minded",
			personaTag4: "Active sharers",
		},
		support: {
			eyebrow: "Creator Support",
			title: "What we offer goes <span>far beyond</span> a platform.",
			desc: "From content production and personal branding to commercial partnerships, our team helps turn your expertise into lasting influence.",
			card1Title: "Create More Efficiently",
			card1Desc:
				"Reduce repetitive work from ideation to publishing and spend more time on the expertise that matters.",
			card1Item1: "· Collaborative Trend-Based Topic Planning",
			card1Item2: "· Accelerated Content Production",
			card1Item3: "· Original Content Copyright Protection",
			card2Title: "Turn Expertise into a Brand",
			card2Desc: "Shape scattered influence into a clear, trusted and recognisable personal brand.",
			card2Item1: "· Positioning & Personal Branding",
			card2Item2: "· Targeted Traffic Support",
			card2Item3: "· Deeper Audience Engagement",
			card3Title: "Monetise Influence Sustainably",
			card3Desc:
				"Connect brands, knowledge products and compliance support to create long-term income opportunities.",
			card3Item1: "· Business Opportunity Matching",
			card3Item2: "· Knowledge Product Development",
			card3Item3: "· Legal & Compliance Support",
		},
		partnership: {
			eyebrow: "Flexible Partnership",
			title: "Choose the partnership that fits your stage.",
			desc: "Whether you are just starting, building authority or already leading your field, there is a clear path forward.",
			tier1Badge: "Creator",
			tier1Title: "Publish content, access basic recommendations and enable paid content.",
			tier1Desc: "For creators ready to share their expertise",
			tier1Sub: "",
			tier1Cta: "Choose this plan",
			tier2Badge: "Verified KOL",
			tier2Title:
				"Includes dedicated operations guidance, priority event access and official verification.",
			tier2Desc: "For creators with established niche expertise",
			tier2Sub: "",
			tier2Cta: "Choose this plan",
			tier3Badge: "Exclusive Strategic Partner",
			tier3Title:
				"Premium reach, personal IP development, network-wide promotion and guaranteed income plus revenue share.",
			tier3Desc: "For influential, leading KOL",
			tier3Sub: '<span><a href="mailto:zixun@seeronnet.com">zixun@seeronnet.com</a></span>',
			tier3Cta: "Discuss by Email",
		},
		growth: {
			eyebrow: "Real Growth",
			title: "Real results. Real creator growth.",
			case1Value: "300",
			case1Suffix: "%",
			case1Metric: "Increase in enquiries",
			case1Author: "{'@'}Astrologer Jupiter",
			case1Desc:
				"The original Seven-Year Zodiac Forecast series precisely connected with its target audience, increasing enquiries by 300% while growing both premium-client share and average order value.",
			case2Value: "200",
			case2Suffix: "K+",
			case2Metric: "Cumulative views in 6 months",
			case2Author: "{'@'}Fei Shu",
			case2Desc:
				"Individual videos initially received fewer than 100 views. After joining the platform's creator incentive programme, cumulative video views surpassed 200K+ within six months.",
			disclaimer:
				"* Results vary by content quality, commitment and audience base. Examples do not guarantee earnings.",
			communityTitle: "Mentor Team",
			community: "200+\nMentors Worldwide",
		},
		steps: {
			eyebrow: "3 Steps to Start",
			title: "Join in three steps. Start your creator journey.",
			desc: "We quickly learn about your expertise and content direction, then a dedicated specialist helps you launch.",
			step1Title: "Submit Application",
			step1Desc: "Share your profile, content focus and portfolio or social links.",
			step1Badge: "About 3 minutes",
			step2Title: "Application Review",
			step2Desc: "Our team reviews expertise, content quality and partnership potential.",
			step2Badge: "Within 3 business days",
			step3Title: "Sign & Launch",
			step3Desc: "Activate your creator account with dedicated launch support.",
			step3Badge: "Dedicated specialist",
		},
	},
	join: {
		metaTitle: "Apply as a Creator",
		title: "Apply as a Creator",
		nickname: "Nickname",
		nicknamePh: "Please enter your nickname.",
		gender: "Gender",
		genderPh: "Please select your gender.",
		genderFemale: "Female",
		genderMale: "Male",
		region: "Region",
		regionPh: "Please select your current region.",
		intro: "Personal Introduction",
		introPh: "Introduce your background, content style, and the audience you hope to reach",
		expertise: "Areas of Expertise",
		expertisePh: "Please describe your area of expertise and services",
		media: "Media Information",
		mediaTip:
			"Upload at least one profile screenshot from an external platform (such as YouTube, Facebook, or Instagram) showing your account name, follower count, recent posts, and content style. JPG and PNG only, up to 6 images.",
		contractType: "Contract Type",
		contractPersonal: "Individual Contract",
		contractPersonalDesc: "Sign the partnership agreement as an individual.",
		contractCompany: "Company Contract",
		contractCompanyDesc: "Sign the partnership agreement as a company.",
		companyName: "Company Name",
		companyNamePh: "Please enter the company name.",
		legalRep: "Company Representative (Legal Representative)",
		legalRepPh: "Please enter the legal representative's name.",
		legalTitle: "Company Representative's Position",
		legalTitlePh: "Please enter the company representative's position.",
		registerCode: "Company Registration Number",
		registerCodePh: "Please enter the company registration number.",
		companyAddress: "Company Address",
		companyAddressPh: "Please enter company address.",
		email: "Email",
		emailPh: "Please enter email.",
		backHome: "Back to Home",
		submit: "Review & Submit",
		submitM: "Submit Application",
		avatarAlt: "Avatar",
		pickImage: "Please select an image",
		imageMax4mb: "Image must be 4MB or smaller",
		uploadNoUrl: "Upload succeeded but no image URL returned",
		uploadSuccess: "Uploaded",
		uploadFail: "Upload failed, please retry",
		submitOk: "Application submitted. Please wait for review.",
		submitFail: "Submit failed, please try again later",
		rules: {
			nickname: "Please enter your nickname.",
			gender: "Please select your gender.",
			region: "Please select your current region.",
			intro: "Please fill in your personal introduction.",
			expertise: "Please describe your area of expertise and services.",
			media: "Please upload at least 1 media image.",
			contractType: "Please select a contract type.",
			companyName: "Please enter the company name.",
			legalRep: "Please enter the legal representative’s name.",
			legalTitle: "Please enter the company representative’s position.",
			registerCode: "Please enter the company registration number.",
			companyAddress: "Please enter company address.",
			email: "Please enter email.",
			emailFormat: "Please enter a valid email.",
		},
	},
	status: {
		download: "Download the SeerQ App",
		app: "See Beyond",
		back: "Back to home",
		processing: {
			title: "Application Under Review",
			text: "Our review team will notify you of the result by email within 3 business days. Please keep an eye on your inbox. You may also download the SeerQ App to receive real-time updates on your application status and review result. Thank you for your cooperation and support.",
		},
		approved: {
			title: "Welcome to SeerQ",
			text: "You are now a certified SeerQ creator. Head to the SeerQ App to publish your content and begin your creator journey.",
		},
		rejected: {
			title: "Sorry, your creator application was not approved.",
			reason: "Reason",
			dec: "You may update your information based on the review feedback and resubmit.",
			edit: "Edit",
		},
	},
	gate: {
		officialCannotApplyCreator: "You are already a certified mentor and cannot apply as a creator.",
	},
};
